import { GlobeIcon, LockIcon, MicIcon } from '@8x8/oxygen-icon'

export const APP_NAME = '8x8 Meet'

export const APP_TYPES = {
  SETTINGS: 'settings',
  SUMMARY: {
    MOBILE: 'summary_mobile',
    SALESFORCE: 'summary_salesforce',
    URL: 'summary_url'
  },
  WORK: 'work'
}

export const ACTION_TYPES = {
  APP: {
    SET_INIT_DATA: 'SET_INIT_DATA',
    SET_LOCALE: 'SET_LOCALE',
    SET_USER_INFO: 'SET_USER_INFO'
  },
  ACTIVE_SESSION: {
    SET_DETAILS: 'SET_DETAILS',
    RESET_ACTIVE_SESSION: 'RESET_ACTIVE_SESSION',
    SET_SESSION_STATUS: 'SET_SESSION_STATUS',
    SET_WAITING_TO_JOIN: 'SET_WAITING_TO_JOIN',
    DISABLE_PREJOIN: 'DISABLE_PREJOIN'
  },
  EVENTS: {
    FETCHING_IN_PROGRESS: 'FETCHING_EVENTS_IN_PROGRESS',
    UPDATE_EVENT: 'UPDATE_EVENT',
    FETCHED_EVENTS: 'FETCHED_EVENTS'
  },
  RECENTS: {
    FETCHED_RECENTS: 'FETCHED_RECENTS',
    FETCHING_IN_PROGRESS: 'FETCHING_RECENTS_IN_PROGRESS',
    HAS_MORE_RECENTS: 'HAS_MORE_RECENTS',
    NEXT_PAGE_START_ID: 'NEXT_PAGE_START_ID',
    SET_PLAYING_RECORDING: 'SET_PLAYING_RECORDING',
    SET_SUMMARY_FEEDBACK_SUBMITTED: 'SET_SUMMARY_FEEDBACK_SUBMITTED',
    TOGGLE_SHARING_UPDATE: 'TOGGLE_SHARING_UPDATE',
    UPDATE_SHARING_STATUS: 'UPDATE_SHARING_STATUS'
  },
  ROOM: {
    SET_CUSTOM_ROOM_NAME: 'SET_CUSTOM_ROOM_NAME',
    SET_PERSONAL_ROOM: 'SET_PERSONAL_ROOM'
  },
  ROOM_SETTINGS: {
    TOGGLE_MODERATION_RIGHTS: 'TOGGLE_MODERATION_RIGHTS',
    SET_PERSONAL_ROOM_PASSSWORD: 'SET_PERSONAL_ROOM_PASSSWORD',
    SET_MEETING_PREVIEW_ENABLED: 'SET_MEETING_PREVIEW_ENABLED',
    SET_UNDOCKED: 'SET_UNDOCKED',
    SET_MODERATION_SETTINGS: 'SET_MODERATION_SETTINGS',
    SET_ACCESS_SETTINGS: 'SET_ACCESS_SETTINGS',
    SET_OVERRIDE_PERMISSIONS: 'SET_OVERRIDE_PERMISSIONS',
    SET_RECORDING_SETTINGS: 'SET_RECORDING_SETTINGS',
    SET_SECURITY_SETTINGS: 'SET_SECURITY_SETTINGS',
    SET_INTENDED_PRESET: 'SET_INTENDED_PRESET',
    SET_USER_IDENTITY: 'SET_USER_IDENTITY'
  },
  SETTINGS: {
    SET_ADDONS: 'SET_ADDONS',
    SET_CONFERENCE_SETTINGS: 'SET_CONFERENCE_SETTINGS',
    SET_SCHEDULE_PERSONAL_ROOM: 'SET_SCHEDULE_PERSONAL_ROOM',
    SET_USER_SETTINGS: 'SET_USER_SETTINGS',
    SET_NEW_MEETINGS_EXPERIENCE: 'SET_NEW_MEETINGS_EXPERIENCE',
    SET_MEET_METRICS_ACCESS: 'SET_MEET_METRICS_ACCESS'
  },
  UI: {
    ADD_VISIBLE_SCREEN: 'ADD_VISIBLE_SCREEN',
    REMOVE_VISIBLE_SCREEN: 'REMOVE_VISIBLE_SCREEN',
    SET_DIALOG: 'SET_DIALOG',
    SET_FULL_SCREEN: 'SET_FULL_SCREEN',
    SET_JOIN_BUTTON_DISABLED: 'SET_JOIN_BUTTON_DISABLED',
    SET_LAYOUT_TYPE: 'SET_LAYOUT_TYPE',
    SET_MEETINGS_TAB: 'SET_MEETINGS_TAB',
    SET_SHOW_UPCOMING_PANEL: 'SET_SHOW_UPCOMING_PANEL',
    SET_ROOM_INPUT_ERROR: 'SET_ROOM_INPUT_ERROR',
    SET_SETTINGS_TAB: 'SET_SETTINGS_TAB',
    SET_THEME: 'SET_THEME',
    SET_VIEWED_SESSION: 'SET_VIEWED_SESSION',
    SET_WINDOW_SIZE: 'SET_WINDOW_SIZE',
    SYNC: 'SYNC'
  },
  CALENDAR: {
    SYNCING_IN_PROGRESS: 'SET_SYNCING_IN_PROGRESS',
    SET_SYNCED: 'SET_SYNCED',
    SET_CALENDAR_DATA: 'SET_CALENDAR_DATA',
    PURGE_CALENDAR_DATA: 'PURGE_CALENDAR_DATA'
  },
  FEATURE_FLAGS: {
    SET_FEATURE_FLAGS: 'SET_FEATURE_FLAGS'
  },
  SCREENSHOTS: {
    FETCHED_SCREENSHOTS: 'FETCHED_SCREENSHOTS',
    FETCHING_IN_PROGRESS: 'FETCHING_SCREENSHOTS_IN_PROGRESS',
    PURGE_SCREENSHOT_DATA: 'PURGE_SCREENSHOT_DATA',
    SET_SELECTED_SCREENSHOT: 'SET_SELECTED_SCREENSHOT'
  },
  SALESFORCE: {
    FETCH_SEARCH_RECORDS_ERROR: 'FETCH_SALESFORCE_SEARCH_RECORDS_ERROR',
    FETCHED_ITEM_DETAILS: 'FETCHED_SALESFORCE_ITEM_DETAILS',
    FETCHED_RECENTS: 'FETCHED_RECENT_SALESFORCE_OBJECTS',
    FETCHED_SEARCH_RECORDS: 'FETCHED_SALESFORCE_SEARCH_RECORDS',
    FETCHED_SESSION_TAGS: 'FETCHED_SALESFORCE_SESSION_TAGS',
    FETCHING_SEARCH_RECORDS: 'FETCHING_SALESFORCE_SEARCH_RECORDS',
    REMOVE_ITEM: 'REMOVE_SALESFORCE_ITEM',
    SET_HAS_PERMISSIONS: 'SET_HAS_PERMISSIONS',
    SET_IS_LOGGED_IN: 'SET_IS_LOGGED_IN',
    SET_SEARCH_TEXT: 'SET_SALESFORCE_SEARCH_TEXT',
    SET_USER_INFO: 'SET_SALESFORCE_USER_INFO'
  },
  SHARED_FILES: {
    FETCHING_IN_PROGRESS: 'FETCHING_SHARED_FILES_IN_PROGRESS',
    FETCHED_SHARED_FILES: 'FETCHED_SHARED_FILES',
    PURGE_SHARED_FILES_DATA: 'PURGE_SHARED_FILES_DATA'
  }
}

export const SESSION_TYPE = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO'
}

export const DIALOGS = {
  ACTION_ITEMS: 'ACTION_ITEMS',
  CALENDARS_LIST: 'CALENDARS_LIST',
  CHAT: 'CHAT',
  CONFIRM_JOIN: 'CONFIRM_JOIN',
  EDIT_NAME: 'EDIT_NAME',
  EDIT_PERSONAL_ROOM: 'EDIT_PERSONAL_ROOM',
  FAILED_JOIN_ROOM: 'FAILED_JOIN_ROOM',
  FEEDBACK: 'FEEDBACK',
  JOIN_CUSTOM_ROOM: 'JOIN_CUSTOM_ROOM',
  LINK: 'LINK',
  NONE: 'NONE',
  PARTICIPANTS: 'PARTICIPANTS',
  POLLS: 'POLLS',
  RECORDING_SLIDESHOW: 'RECORDING_SLIDESHOW',
  SALESFORCE_ADD: 'SALESFORCE_ADD',
  SALESFORCE_REMOVE: 'SALESFORCE_REMOVE',
  SCREENSHOTS_SLIDESHOW: 'SCREENSHOTS_SLIDESHOW',
  SHARE_MEETING: 'SHARE_MEETING',
  SHARED_MATERIALS: 'SHARED_MATERIALS',
  SPEAKER_STATS: 'SPEAKER_STATS',
  SUMMARY: 'SUMMARY',
  SWITCH_MEETING: 'SWITCH_MEETING',
  TRANSCRIPTIONS: 'TRANSCRIPTIONS',
  USER_PROFILE: 'USER_PROFILE',
  VIEW_JOIN_OPTIONS: 'VIEW_JOIN_OPTIONS'
}

export const TABS = {
  RECENT: 'RECENT',
  UPCOMING: 'UPCOMING'
}

export const CALENDAR_PROVIDERS = {
  apple: 'Apple',
  cronofy: 'Cronofy',
  exchange: 'Exchange',
  google: 'Google',
  live_connect: 'Live Connect',
  office365: 'Office 365',
  none: 'None'
}

export const UPDATE_INTERVAL = 60 * 1000

export const NOTIFICATIONS = {
  ACCOUNT_DELETED: 'ACCOUNT_DELETED',
  CALENDAR_EVENT: 'CALENDAR_EVENT',
  CALENDAR_SYNC_DENIED: 'CALENDAR_SYNC_DENIED',
  CALENDAR_SYNC_OK: 'CALENDAR_SYNC_OK',
  RECENTS: 'RECENTS',
  SALESFORCE_AUTH: 'SALESFORCE_AUTH',
  SALESFORCE_RECORD: 'SALESFORCE_RECORD',
  SALESFORCE_SYNC_DENIED: 'SALESFORCE_SYNC_DENIED',
  SALESFORCE_SYNC_OK: 'SALESFORCE_SYNC_OK',
  SESSION_UPDATED: 'SESSION_UPDATED'
}

export const EDIT_PERSONAL_ROOM_SCREENS = {
  MAIN: 'MAIN',
  EDIT_SUCCESS: 'EDIT_SUCCESS',
  CONFIRM_UPDATE_PASSWORD: 'CONFIRM_UPDATE_PASSWORD',
  COPY_NEW_INFO: 'COPY_NEW_INFO'
}

export const PERSONAL_ROOM_PASSWORD_REGEX = /^\d{0,8}$/

export const ROOM_MEETING_NAME_REGEX = /^[a-z0-9][a-z0-9._-]*$/i
export const RESERVED_URL_CHARACTERS_REGEX = /[\s?#[\]@!$&'%()*+,;=\\{}`]/
export const URL_REGEX = /(?:https:\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/ig
export const CUSTOM_ROOM_VALIDATION_FAILED = 'validation.failed'

export const LAYOUT_TYPES = {
  NARROW: Symbol('narrow'),
  WIDE: Symbol('wide')
}

export const LARGE_LAYOUT_THRESHOLD = 743

// String values (not Symbols): sessionStatus is compared with === across the
// reducer, selectors and the meet MFE. Symbols are reference-unique, so if
// constants.js is evaluated in more than one module realm (module-federation
// remote, a re-loaded/re-mounted chunk) the CLOSED symbol held in state would
// no longer === the CLOSED symbol a selector compares against, and
// getIsSessionClosed could return false for a genuinely closed session.
// Strings are stable across realms, removing that latent hazard. (JIT-15871)
export const SESSION_STATUSES = {
  RECEIVED_DETAILS: 'received-details',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  CLOSED: 'closed'
}

export const MAX_RECENTS_RESULTS = 10

export const VIEW_ONLY_CONFIGS = {
  customRoomConfigs: {
    config: {
      startSilent: true
    }
  }
}

/**
 * Events that are currently being interpreted and handled by the
 * bridge EventEmitter.
 */
export const BRIDGE_EVENTS = {
  SCREEN_SHARING_STATUS_CHANGED: 'screenSharingStatusChanged',
  USER_LOGOUT: 'user-logout',
  UPDATE_DEEPLINKING: 'update-deeplinking',
  UPDATE_UNDOCKED: 'update-undocked'
}

export const CALL_USING_TYPE = {
  COMPUTER: 'computer',
  DESKPHONE: 'deskphone',
  NUMBER: 'number'
}

export const DID_STORAGE_NAME = '__AMDID'
export const LOGS_STORAGE_NAME = 'logs'

export const PRO = 'Pro'
export const BASIC = 'Basic'

export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
  SYSTEM_DEFAULT: 'system-default'
}

export const SUPPORTED_LANGUAGES = [
  'de',
  'en',
  'es',
  'es-419',
  'fi',
  'fr',
  'fr-CA',
  'it',
  'nl',
  'pt-BR',
  'sv'
]

export const JOIN_TYPES = {
  PERSONAL: Symbol('personal_room'),
  CUSTOM: Symbol('custom_room'),
  URL: Symbol('url')
}

export const KEY_CODES = {
  ENTER: 13
}

export const Z_INDEX = {
  BASIC: 1,
  MODALS: 2000,
  NOTIFICATIONS: 2001,
  OVERLAYS: 99
}

export const CDN_URL = 'https://vo-cdn.8x8.vc/static'

export const SALESFORCE_TYPES = {
  ACCOUNT: 'ACCOUNT',
  CONTACT: 'CONTACT',
  LEAD: 'LEAD',
  OPPORTUNITY: 'OPPORTUNITY'
}

export const AVATAR_COLORS = [
  '#6A50D3',
  '#FF9B42',
  '#DF486F',
  '#73348C',
  '#B23683',
  '#F96E57',
  '#4380E2',
  '#2AA076',
  '#00A8B3'
]

export const HTTP_STATUS = {
  CONFLICT: 409,
  FORBIDDEN: 403,
  NOT_ALLOWED: 405,
  OK: 200
}

export const LINK_TYPES = {
  GOOGLE_DOC: 'GOOGLE_DOC',
  GOOGLE_SHEET: 'GOOGLE_SHEET',
  GOOGLE_SLIDE: 'GOOGLE_SLIDE',
  PDF: 'PDF',
  IMAGE: 'IMAGE',
  LINK: 'LINK',
  VIDEO: 'VIDEO',
  UNKNOWN: 'UNKNOWN'
}

export const FILENAME_LINK_TYPES = [LINK_TYPES.PDF, LINK_TYPES.IMAGE, LINK_TYPES.VIDEO]
export const HARDCODED_LINK_TYPES = {
  [LINK_TYPES.GOOGLE_DOC]: 'Google docs',
  [LINK_TYPES.GOOGLE_SHEET]: 'Google sheets',
  [LINK_TYPES.GOOGLE_SLIDE]: 'Google slides'
}
export const LINK_MAPPINGS = [
  {
    matcher: /docs.google.com\/document/i,
    type: LINK_TYPES.GOOGLE_DOC
  },
  {
    matcher: /docs.google.com\/spreadsheets/i,
    type: LINK_TYPES.GOOGLE_SHEET
  },
  {
    matcher: /docs.google.com\/presentation/i,
    type: LINK_TYPES.GOOGLE_SLIDE
  },
  {
    matcher: /^.*\.(jpe?g|png|gif|bmp)$/i,
    type: LINK_TYPES.IMAGE
  },
  {
    matcher: /^.*\.(pdf)$/i,
    type: LINK_TYPES.PDF
  },
  {
    matcher: /^.*\.(mp4|mov|webm)$/i,
    type: LINK_TYPES.VIDEO
  }
]

export const MAX_SCREENSHOTS_RESULTS = 8

export const MAX_SHARED_FILES_RESULTS = 4

export const DOCK_IPC = {
  CLOSED: 'closed',
  CRASHED: 'crashed',
  CRASHED_AND_CLOSED: 'crashed-and-closed',
  CUSTOM_NOTIFICATION_ACTION_TRIGGERED: 'custom-notification-action-triggered',
  DOCK_STATE_CHANGED: 'dock-state-changed',
  DISPOSE: 'dispose',
  FOCUS: 'focus',
  HIDE_NOTIFICATION: 'hide-notification',
  JOIN: 'join',
  JOIN_FAILED: 'join-failed',
  LOADED: 'loaded',
  LOG: 'log',
  ROOM_JOINED: 'room-joined',
  ROOM_LEFT: 'room-left',
  SCREENSHARING_STATUS_CHANGED: 'screensharing-status-changed',
  SHOW_NOTIFICATION: 'show-notification',
  SET_AUDIO_MUTE: 'set-audio-mute',
  UPDATE_PIP_CONFIG: 'update-pip-config'
}

export const FUNCTIONS = {
  NOOP: () => {},
  NULL: () => null
}

export const IFRAME_CONTAINER_ID = 'jitsi-meet-iframe-container'

export const CURRENT_SCRIPT_SRC = new URL(document.currentScript.src)
export const CURRENT_SCRIPT_SRC_ORIGIN = CURRENT_SCRIPT_SRC.origin

export const IS_VALID_ELECTRON_ENVIRONMENT = Boolean(window.workd?.meetings?.jitsiMeetElectronUtils)
export const IS_ELECTRON_WINDOW_HIDING_SUPPORTED = Boolean(window.workd?.meetings?.isWindowHidingSupported?.())

export const WORK_SCREENS = {
  MAIN: 'MeetingScreen',
  SETTINGS: 'MeetingSettings'
}

export const CALENDAR_EVENT_PROVIDERS = {
  EGHT: '8x8',
  GOOGLE_MEET: 'Google Meet',
  MS_TEAMS: 'MS Teams',
  WEBEX: 'Webex',
  JITSI: 'Jitsi',
  ZOOM: 'Zoom',
  RING_CENTRAL: 'RingCentral',
  GO_TO: 'GoTo',
  BLUE_JEANS: 'BlueJeans',
  WHEREBY: 'Whereby',
  UNKNOWN: 'Unknown'
}

export const MODERATION_TYPE = {
  ONLY_ME: 'ONLY_ME',
  SPECIFIC_MEMBERS: 'SPECIFIC_MEMBERS',
  ALL_MEMBERS: 'ALL_MEMBERS'
}

export const VISITOR_PROMOTION_TYPE = {
  RAISE_HAND: 'RAISE_HAND',
  MODERATOR_APPROVAL: 'MODERATOR_APPROVAL'
}

export const ROLE = {
  PARTICIPANT: 'PARTICIPANT',
  MODERATOR: 'MODERATOR'
}

export const ACTIVE_PARTICIPANT_LIMIT = 50

export const PASSCODE_VALIDATION = /^\+?\d{1,8}$/

export const MEETING_SETTINGS_PRESET = {
  PUBLIC: {
    label: 'meeting_settings_public_preset',
    labelPlural: 'meeting_settings_public_preset_plural',
    description: 'meeting_settings_public_preset_description',
    value: 'PUBLIC',
    icon: GlobeIcon
  },
  PRIVATE: {
    label: 'meeting_settings_private_preset',
    labelPlural: 'meeting_settings_private_preset_plural',
    description: 'meeting_settings_private_preset_description',
    value: 'PRIVATE',
    icon: LockIcon
  },
  LARGE: {
    label: 'meeting_settings_large_preset',
    labelPlural: 'meeting_settings_large_preset_plural',
    description: 'meeting_settings_large_preset_description',
    value: 'LARGE',
    icon: MicIcon
  }
}

export const MEETING_SETTINGS_PRESET_LIST = [
  MEETING_SETTINGS_PRESET.PUBLIC,
  MEETING_SETTINGS_PRESET.PRIVATE,
  MEETING_SETTINGS_PRESET.LARGE
]

export const LOBBY_TYPE = {
  WAIT_FOR_APPROVAL: 'WAIT_FOR_APPROVAL',
  WAIT_FOR_MODERATOR: 'WAIT_FOR_MODERATOR'
}
